import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_QUALITY_INDICATORS } from '@custom/constant';

interface Payload {
    year: number
}

const getQualityIndicators = createAsyncThunk('getQualityIndicators', async (payload: Payload, { rejectWithValue }) => {
    try {

        const token = sessionStorage.getItem('token') || localStorage.getItem('token');
        const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
        let url = `${GET_QUALITY_INDICATORS}?hospitalId=${hospitalId}`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            const errorData = await response.json();
            return rejectWithValue(errorData.msg || 'Get quality Indicators failed');
        }
        return await response.json();
    } catch (error) {
        return Promise.reject(error);
    }
});

export default getQualityIndicators;
